import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { getMostReadArticles } from './../actions.js';
import { LoadMore } from './../../ui/src/component/loadMore';
import { StandardArticleCustom } from './../component/standardArticleCustom';
import { Spinner } from './../../ui/src/component/spinner';
import Helmet from 'react-helmet';
import { getProp } from '../../ui/src/utilities';

class MostRead extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      interval: '24h',
    };
  }

  componentDidMount() {
    this.fetchMostRead();
  }

  changeInterval(newInterval) {
    this.setState({ interval: newInterval }, () => {
      this.fetchMostRead();
    });
  }

  fetchMostRead() {
    this.props.dispatch(getMostReadArticles(this.state.interval));
  }

  onClickMore(offset) {
    this.props.dispatch(getMostReadArticles(this.state.interval, offset));
  }

  render() {
    const {locationSmartTags} = this.props;
    const interval = this.props.mostRead[this.state.interval];
    const articles = getProp(interval, 'articles', []);
    const articlesNextOffset = getProp(interval, 'nextOffset', null);

    return (
      <div className="most-read">
        <Helmet title={'Najčítanejšie články'} />

        <div className="bg-alt-light article-header">
          <div className="container">
            <div className="article-header-title">
              <h1>Najčítanejšie</h1>
            </div>
          </div>
        </div>

        <div className="section">
          <div className="container">
            <div className="text-center">
              <ul className="nav nav-pills">
                <li className={cx({ active: this.state.interval === '24h' })}>
                  <a
                    onClick={e => {e.preventDefault(); this.changeInterval('24h')}}
                    href=""
                  >
                    za 24h
                  </a>
                </li>
                <li className={cx({ active: this.state.interval === '3d' })}>
                  <a
                    onClick={e => {e.preventDefault(); this.changeInterval('3d')}}
                    href=""
                  >
                    za 3 dni
                  </a>
                </li>
                <li className={cx({ active: this.state.interval === '7d' })}>
                  <a
                    onClick={e => {e.preventDefault(); this.changeInterval('7d')}}
                    href=""
                  >
                    za 7 dní
                  </a>
                </li>
                <li className={cx({ active: this.state.interval === '30d' })}>
                  <a
                    onClick={e => {e.preventDefault(); this.changeInterval('30d')}}
                    href=""
                  >
                    za 30 dní
                  </a>
                </li>
                <li className={cx({ active: this.state.interval === '' })}>
                  <a
                    onClick={e => {e.preventDefault(); this.changeInterval('')}}
                    href=""
                  >
                    celkovo
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Spinner show={this.props.mostReadFetching && articles.length === 0}>
          <div className="container">
            <div className="row">
              {articles.map(item => {
                return (
                  <div key={item._id} className="col-sm-6 col-md-3">
                    <StandardArticleCustom
                      article={item}
                      viewCountShow={true}
                      locationSmartTags={locationSmartTags}
                    />
                  </div>
                );
              })}
            </div>
            {articles.length === 0 &&
              this.props.mostReadFetching === false && (
                <div className="text-center" style={{ paddingBottom: '50px' }}>
                  <h2>Žiadne články za vybrané obdobie</h2>
                </div>
              )}
          </div>
        </Spinner>

        {articlesNextOffset !== null && (
          <div className="text-center section">
            <LoadMore
              show={true}
              onClick={this.onClickMore.bind(this, articlesNextOffset)}
            />
          </div>
        )}
      </div>
    );
  }
}

MostRead.propTypes = {
  dispatch: PropTypes.func.isRequired,
  mostRead: PropTypes.object.isRequired,
  mostReadFetching: PropTypes.bool,
  locationSmartTags: PropTypes.array.isRequired
};

export default connect(state => {
  return {
    mostRead: state.mostRead.interval,
    mostReadFetching: state.mostRead.isFetching,
    locationSmartTags: state.locationSmartTags.data.values,
  };
})(MostRead);



// WEBPACK FOOTER //
// ./src/app/container/mostRead.js